export const useDevice = () => {
  const isMobile = ref(false)
  const isTablet = ref(false)
  const isDesktop = ref(true)

  const setDevice = (deviceInfo) => {
    isMobile.value = deviceInfo.isMobile
    isTablet.value = deviceInfo.isTablet
    isDesktop.value = deviceInfo.isDesktop
  }

  return {
    isMobile: readonly(isMobile),
    isTablet: readonly(isTablet),
    isDesktop: readonly(isDesktop),
    setDevice
  }
}